import React from "react";

import { Container, Card, P, H1, H2 } from "./TermsofServiceElements";

const Disclaimer = () => {
  return (
    <>
      <Container>
        <Card>
          <H1> Terms of Service </H1>
          <P>
            These terms of service ("Terms") govern the use of the recruitment
            services provided by Structural Connections ("we", "us", "our") to
            clients and job seekers ("you", "your"). By using our services, you
            agree to be bound by these Terms.
          </P>

          <P>
            <H2> Recruitment Services: </H2>
            We provide recruitment services to help clients find suitable
            candidates for job openings and to help job seekers find suitable
            job opportunities. Our services include but are not limited to job
            postings, resume screening, candidate interviews, and placement
            services.
          </P>

          <P>
            <H2> Fees: </H2>
            Our fees for recruitment services vary depending on the scope of the
            services provided. We will provide you with a fee agreement that
            outlines the scope of services and the applicable fees. Fees are due
            and payable upon receipt of our invoice.
          </P>

          <P>
            <H2> Confidentiality:</H2>
            We will maintain the confidentiality of your personal information
            and any confidential information provided to us during the
            recruitment process. We will not disclose your personal information
            or confidential information to any third party without your consent,
            except as required by law or as necessary to provide recruitment
            services.
          </P>

          <P>
            <H2> Intellectual Property:</H2>
            All content and materials provided by us, including but not limited
            to job postings, website content, and software, are owned by us and
            protected by intellectual property laws. You may not use, copy, or
            distribute any content or materials without our prior written
            consent.
          </P>

          <P>
            <H2> Disclaimer of Warranties:</H2>
            We make no representations or warranties of any kind, express or
            implied, as to the suitability, reliability, or accuracy of the
            information provided through our services. We do not guarantee that
            the candidates we provide will meet the specific requirements or
            expectations of any employer.
          </P>

          <P>
            <H2> Limitation of Liability:</H2>
            In no event shall we be liable for any damages whatsoever, including
            but not limited to direct, indirect, special, or consequential
            damages, arising out of or in connection with the use or inability
            to use our services.
          </P>

          <P>
            <H2> Indemnification:</H2>
            You agree to indemnify and hold us harmless from and against any and
            all claims, damages, liabilities, costs, and expenses, including
            reasonable attorneys' fees, arising out of or in connection with
            your use of our services.
          </P>

          <P>
            <H2> Governing Law:</H2>
            These Terms shall be governed by and construed in accordance with
            the laws of the state in which we are located, without giving effect
            to any principles of conflicts of law.
          </P>

          <P>
            <H2> Modification of Terms:</H2>
            We reserve the right to modify these Terms at any time without prior
            notice. Your continued use of our services following any such
            modification constitutes your agreement to be bound by the modified
            Terms.
          </P>
        </Card>
      </Container>
    </>
  );
};

export default Disclaimer;
